var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown ? _c("app-toolbar") : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-margin": "" } },
        [
          _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-card",
                        [
                          _c(
                            "w-card-title",
                            [
                              _vm._v(" " + _vm._s(_vm.title) + " "),
                              _c("w-spacer"),
                              _vm.isOwner
                                ? _c(
                                    "w-dropdown",
                                    {
                                      attrs: {
                                        flat: "",
                                        sm: "",
                                        items: _vm.menuItems,
                                        right: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return $event()
                                        },
                                      },
                                    },
                                    [
                                      _c("w-fa", {
                                        attrs: { icon: "ellipsis-v" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "w-list",
                            [
                              _vm._l(_vm.users, function (u) {
                                return _c(
                                  "w-list-item",
                                  { key: u.ID },
                                  [
                                    _c("w-list-item-icon", [
                                      _c("img", {
                                        staticClass: "profile-img",
                                        attrs: {
                                          src: u.getProfileImgUrl(),
                                          alt: "Profile img",
                                        },
                                      }),
                                    ]),
                                    _vm.$wf.isMdUp
                                      ? [
                                          _c("w-list-item-text", [
                                            _vm._v(_vm._s(u.getUserString())),
                                          ]),
                                          _c("w-list-item-text", [
                                            u.hasAccessToDossier(
                                              _vm.currentDossierID
                                            )
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("w-fa", {
                                                      staticClass:
                                                        "access-granted",
                                                      attrs: { icon: "check" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$ct(
                                                            "dossier-access-granted"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  [
                                                    _c("w-fa", {
                                                      staticClass:
                                                        "access-denied",
                                                      attrs: { icon: "ban" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$ct(
                                                            "dossier-access-denied"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ]),
                                        ]
                                      : [
                                          _c("w-list-item-text", [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(u.getUserFullName()) +
                                                  " "
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                " (" + _vm._s(u.Email) + ") "
                                              ),
                                            ]),
                                            u.hasAccessToDossier(
                                              _vm.currentDossierID
                                            )
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("w-fa", {
                                                      staticClass:
                                                        "access-granted",
                                                      attrs: { icon: "check" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$ct(
                                                            "dossier-access-granted"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  [
                                                    _c("w-fa", {
                                                      staticClass:
                                                        "access-denied",
                                                      attrs: { icon: "ban" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$ct(
                                                            "dossier-access-denied"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ]),
                                        ],
                                    _c(
                                      "w-list-item-action",
                                      [
                                        _c(
                                          "w-button",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$ct("login-as-user"),
                                                expression:
                                                  "$ct('login-as-user')",
                                              },
                                            ],
                                            attrs: {
                                              disabled:
                                                !_vm.isOwner ||
                                                u.ID == _vm.loggedInUserID,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.loginAsUser(u)
                                              },
                                            },
                                          },
                                          [
                                            _c("w-fa", {
                                              attrs: { icon: "sign-in-alt" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "w-list-item-action",
                                      [
                                        _c(
                                          "w-button",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$ct("common.edit"),
                                                expression:
                                                  "$ct('common.edit')",
                                              },
                                            ],
                                            attrs: {
                                              disabled: !_vm.canUserBeEdited(u),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editUser(u)
                                              },
                                            },
                                          },
                                          [
                                            _c("w-fa", {
                                              attrs: { icon: "pen" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "w-list-item-action",
                                      [
                                        _c(
                                          "w-button",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$ct("edit-views"),
                                                expression: "$ct('edit-views')",
                                              },
                                            ],
                                            attrs: {
                                              disabled:
                                                !_vm.canUserBeEdited(u) ||
                                                !_vm.hasAccessToCurrentDossier(
                                                  u
                                                ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editUserViews(u)
                                              },
                                            },
                                          },
                                          [
                                            _c("w-fa", {
                                              attrs: { icon: "window-restore" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "w-list-item-action",
                                      [
                                        _c(
                                          "w-button",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$ct("common.delete"),
                                                expression:
                                                  "$ct('common.delete')",
                                              },
                                            ],
                                            staticClass: "danger",
                                            attrs: {
                                              disabled: !_vm.canUserBeEdited(u),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeUser(u)
                                              },
                                            },
                                          },
                                          [
                                            _c("w-fa", {
                                              attrs: { icon: "trash" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                )
                              }),
                              _c(
                                "w-list-item",
                                {
                                  attrs: { disabled: _vm.maxUsersReached },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addClicked()
                                    },
                                  },
                                },
                                [
                                  _c("w-list-item-text", [
                                    _c(
                                      "div",
                                      [
                                        _c("w-fa", { attrs: { icon: "plus" } }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$ct("create-new-user")) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.copyViewsModal, "full-height": "" } },
        [
          _vm.copyViewsModal
            ? _c("app-users-copy-views", {
                on: {
                  close: function ($event) {
                    _vm.copyViewsModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.shareViewsModal
        ? _c("app-users-share-views-modal", {
            on: {
              close: function ($event) {
                _vm.shareViewsModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }